import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import styles from "./ImportTemplateModal.module.css";
import { IoIosClose } from "react-icons/io";
import { connect, useDispatch } from "react-redux";
import {themeColors} from "../../theme";
import { motion,AnimatePresence } from "framer-motion";
import Backdrop from "../../Backdrop/Backdrop";
import Label from "../../Label";
import Dropdown from "../../DropDown/Dropdown";
import Select from "react-select";
import makeAnimated from "react-select/animated";


type props = {
  open: boolean;
  close: () => void;
  heading: string;
  title: string;
  onSave: (value: any,textareaValue:any) => void;
  theme:any;
};

const dropIn = {
  hidden: {
    y: "-100vh",
    opacity: 1,
  },
  visible: {
    y: "0",
    opacity: 1,
    transition: {
      duration: 1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
};

const ImportTemplateModal: FunctionComponent<props> = ({
  open,
  close,
  heading,
  title,
  onSave,
  theme,
}) => {
  const [value, setValue] = useState("");
  const animatedComponents = makeAnimated();
  const containerStyles ={ backgroundColor:theme ? themeColors.backgroundColor:themeColors.backgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark} 
  const [textareaValue, setTextareaValue] = useState("");
  const option = ["Customer Name","Project Name","Lead Owner Name","Lead Owner Number","Follow Up Time","Project Address","Project Map Link","Lead Owner Email","Lead Number","Project Details"]
  const textareaRef = useRef<HTMLTextAreaElement>(null);
    const onClick = ((value1: any)=>{
      if (textareaRef.current) {
        const textarea = textareaRef.current;
        const startPos = textarea.selectionStart;
        const endPos = textarea.selectionEnd;
  
        const newValue = textareaValue.substring(0, startPos) + ` {{${value1}}} ` + textareaValue.substring(endPos);
  
        setTextareaValue(newValue);
        const newCursorPos = startPos + value1.length + 6;
  
        textarea.value = newValue;
        textarea.setSelectionRange(newCursorPos, newCursorPos);
        
        const scrollTop = textarea.scrollTop;
        textarea.focus();
        textarea.scrollTop = scrollTop;
      }
    })
    const handleTextareaChange = (event:React.ChangeEvent<HTMLTextAreaElement>) => {
      setTextareaValue(event.target.value);
    };
    const buttonsRows = [];
    for (let i = 0; i < option.length; i += 4) {
      const row = option.slice(i, i + 4);
      const rowButtons = row.map((buttonValue, index) => (
        <div className={`${styles.nameBox} button-column`}>
        <button className={`${styles.change} column-button`}
          key={index}
          onClick={() => onClick(buttonValue)}
        >
          {buttonValue}
        </button>
        </div>
      ));
      buttonsRows.push(
        <div key={i} className="button-row">
          {rowButtons}
        </div>
      );
    }
  return (

     <Backdrop>
      <motion.div
        key="modal"
        className="card p-4 shadow rounded"
        style={{position: "absolute",
        ...containerStyles}}
        variants={dropIn}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <div className={styles.headingContainer}>
      <h6
      >{"Enter Template Name"}</h6>   
      </div>
      <input
          className="form-control"
          style={{  flex: 1,fontSize:"14px"}}
          placeholder={"Enter Template Name"}
          onChange={(event) => setValue(event.target.value)}
        />
      <div className={styles.headingContainer}>
      <h6 
      >{heading}</h6>      
      </div>
        <div className={styles.nameBox} style={{marginTop:"-0.5rem"}}>
      {buttonsRows}
      </div>
      <div className={styles.headingContainer}>
        <h6>{title}:</h6>
      </div>
      <div>
        <textarea
          className="form-control"
          // placeholder={"Enter Template Details"}
          style={{  flex: 1,fontSize:"14px",height:"250px"}}
          ref={textareaRef}
        value={textareaValue}
        onChange={handleTextareaChange}
        />
      </div>
      <div className={styles.button}>

      <button className={styles.saveBtn} onClick={() => {
        onSave(value,textareaValue)}}>
          Save
        </button>
        <button className={styles.cancelBtn} onClick={close}>
          Close
        </button>
      </div>
      </motion.div>
     </Backdrop>
  );
};



const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    contacts: state.contacts,
    theme: state.theme.isLightMode
  };
};

export default connect(mapStateToProps)(ImportTemplateModal);

